import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export const LoadingHeader = () => (
	<Box display='flex' width='100%' sx={{ alignItems: 'center' }}>
		<Skeleton
			animation='wave'
			variant='rounded'
			height='55px'
			width='55px'
			sx={{ mr: '10px' }}
		/>
		<Stack width='100%'>
			<Skeleton animation='wave' variant='text' width='70%' height='2em' />
			<Skeleton animation='wave' variant='text' width='32%' />
		</Stack>
	</Box>
);
